const palette = {
  error: {
    lightest: 'hsla(348, 95%, 95%, 1)',
    light: 'hsla(348, 95%, 85%, 1)',
    main: 'hsla(348, 95%, 57%, 1)',
    dark: 'hsla(348, 95%, 20%, 1)',
  },
  warning: {
    lightest: 'hsla(40, 100%, 95%, 1)',
    light: 'hsla(40, 100%, 85%, 1)',
    main: 'hsla(40, 100%, 57%, 1)',
    dark: 'hsla(40, 100%, 20%, 1)',
    gradient: 'linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFF7E6;',
  },
  info: {
    lightest: 'hsla(199, 98%, 95%, 1)',
    light: 'hsla(199, 98%, 85%, 1)',
    main: 'hsla(199, 98%, 48%, 1)',
    dark: 'hsla(199, 98%, 20%, 1)',
  },
  viewAsTenant: {
    dark: 'hsla(199, 98%, 85%, 1)',
    light: 'hsla(199, 98%, 95%, 1)',
    contrastText: 'hsla(199, 98%, 48%, 1)',
  },
  success: {
    lightest: 'hsla(122, 57%, 95%, 1)',
    light: 'hsla(122, 57%, 85%, 1)',
    main: 'hsla(120, 57%, 49%, 1)',
    dark: 'hsla(122, 84%, 24%, 1)',
  },
  accent: {
    main: '#282143',
    dark: '#433c5d',
    disabled: 'rgba(67, 60, 93, 0.25);',
  },
  text: {
    primary: '#18171D',
    secondary: '#302D39',
    tertiary: '#898593',
    body: 'rgba(48, 45, 57, 0.80)',
    disabled: '#B3B1BA',
    zinc: '#3F3F46',

    // TODO: Possibly move these to 'neutral' to make it easier to understand.
    // slightly modified color props for button style generation.
    lightest: '#B3B1BA',
    lightish: '#64616B',
    light: '#898593',
    main: '#302D39',
    dark: '#18171D',
    contrastText: '#18171D',
  },
  // Used by default for card buttons, dropdown triangles, list item icons and buttons
  action: {
    active: '#6B7280',
    focus: 'rgba(55, 65, 81, 0.12)',
    hover: 'rgba(55, 65, 81, 0.04)',
    buttonHover: 'rgba(55, 65, 81, 0.04)',
    selected: 'rgba(55, 65, 81, 0.08)',
    disabledBackground: 'rgba(55, 65, 81, 0.12)',
    disabled: 'rgba(55, 65, 81, 0.26)',
    activatedOpacity: 0.12,
    disabledOpacity: 0.38,
    hoverOpacity: 0.55,
    selectedOpacity: 0.08,
  },
  common: {
    outline: '#E9E9E9',
    divider: '#f0f0f0',
    white: '#fff',
    input: '#cdcdcd',
    defaultWhite: '#ffffff',
    defaultGray: '#B3B1BA',
  },
  outline: {
    main:'#D9D9D9',
    contrastText: '#000',

  },
  code: {
    background: '#f0f0f0',        // White background
    text: '#000000',             // Black text
    punctuation: '#666666',      // Gray for punctuation
    keyword: '#0070F3',          // Vercel blue for keywords
    string: '#50E3C2',           // Teal for strings
    function: '#0070F3',         // Vercel blue for functions
    comment: '#999999',          // Light gray for comments
    variable: '#FF0080',         // Pink for variables
    number: '#0070F3',           // Vercel blue for numbers
    operator: '#666666',         // Gray for operators
    highlight: '#FAFAFA',        // Very light gray for highlights
    border: '#EAEAEA',           // Light gray for borders
  }
};

export default palette;
